import React from 'react'
import { Link, navigate } from 'gatsby'
import SVG from 'react-inlinesvg'

import trackLink from '../../utils/helpers/tracking/track-link'
import external from '../../assets/icons/external-link.svg'

const LinkCustom = props => {
  const link = props.to ? props.to : ''
  const isInternalLink = link.startsWith('/')
  const isTracked = props.trackClick && props.trackClick.eventAction && props.trackClick.eventAction !== null ? true : false

  // Track Links on click
  const handleClick = event => {
    if (isTracked) {
      if (isInternalLink) {
        event.preventDefault()
        trackLink(props.trackClick)
        return navigate(link)
      } else {
        trackLink(props.trackClick)
      }
    }
  }

  // Empty Links
  if (!link || link === null) {
    return <span>{props.children}</span>
  }

  // Internal links
  if (isInternalLink) {
    // Use navigate function when tracking is needed
    if (isTracked) {
      return (
        <a
          href={link}
          className={props.className}
          onClick={handleClick}
        >
          {props.children}
        </a>
      )
    }
    // Use the Gatsby Link component for non-tracked internal links
    return (
      <Link
        to={link}
        className={props.className}
        style={props.style}
      >
        {props.children}
      </Link>
    )
  }

  // Plain <a> tags for external links
  const ExternalIndicator = () => {
    if (props.disableIndicator) {
      return ''
    }
    return (
      <SVG
        onError={error => console.log(error.message)}
        cacheRequests={true}
        preProcessor={code =>
          code.replace(/fill=".*?"/g, 'fill="currentColor"')
        }
        src={external}
        className="externallink-indicator ml-4 inline-block w-5 text-grayMedium"
      />
    )
  }
  return (
    <a
      href={link}
      target="_blank"
      rel="noreferrer noopener"
      className={props.className}
      onClick={handleClick}
    >
      {props.children}
      <ExternalIndicator />
    </a>
  )
}

export default LinkCustom
